import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { KeyRound, Loader2, MailCheck } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";
import SEO from "../components/SEO";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Erro ao enviar");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center">
      <SEO title="Esqueci minha senha" path="/esqueci-senha" noindex />
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="w-14 h-14 mx-auto rounded-2xl bg-primary flex items-center justify-center mb-3">
            {sent ? <MailCheck className="w-7 h-7 text-primary-foreground" /> : <KeyRound className="w-7 h-7 text-primary-foreground" />}
          </div>
          <h1 className="font-heading font-bold text-2xl">Esqueci minha senha</h1>
          <p className="text-sm text-muted-foreground">Enviaremos um link de redefinição por e-mail</p>
        </div>
        {sent ? (
          <div data-testid="forgot-sent" className="text-center space-y-4">
            <p className="text-sm text-muted-foreground">
              Se existir uma conta com <b>{email}</b>, você receberá um e-mail com o link para criar uma nova senha.
              Verifique também a caixa de spam.
            </p>
            <Link data-testid="forgot-back-login" to="/login" className="inline-block text-primary font-semibold text-sm">Voltar para o login</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="Seu e-mail" className="w-full h-12 px-4 rounded-2xl bg-card border border-border focus:ring-2 focus:ring-primary outline-none" />
            <button data-testid="forgot-submit" type="submit" disabled={loading}
              className="w-full h-12 rounded-2xl bg-primary text-primary-foreground font-semibold flex items-center justify-center disabled:opacity-60 active:scale-95 transition-transform">
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Enviar link de redefinição"}
            </button>
            <p className="text-center text-sm text-muted-foreground pt-2">
              Lembrou a senha? <Link data-testid="forgot-to-login" to="/login" className="text-primary font-semibold">Entrar</Link>
            </p>
          </form>
        )}
      </motion.div>
    </div>
  );
}
